import CONFIG from './Config.module.css';
import styles from './Index.module.css'

import { DropdownCity } from './DropdownCity.jsx';
import { LeftLinks } from './LeftLinks.jsx';
import { TopStripe } from './TopStripe.jsx';
import { NavLogo } from './NavLogo.jsx';
import { MobileMenu } from './MobileMenu.jsx';
import { useEffect, useRef, useState } from 'react';
import { openSignIn, WelcomeLinks } from './WelcomeLinks.jsx';
import { SearchFilter } from '../../SearchBar/SearchFilter.jsx';
import { GLOBAL_TOOME_SEARCH } from '../../../pages/global/links/index.js';
import { API_V2_AUTHENTICATED } from '../../../api/v2/routes/auth/index.js';
import { API_V2_USER_GET } from '../../../api/v2/routes/User.js';
import { useSearchParams } from 'react-router-dom';
import { utils_iam_iframe } from '../../utils/utils_iam_iframe.js';
import { AppDownloadModal } from './AppDownloadModal.jsx';

export const NavBarSiteSearchParamsValues = {
    city_id: 'city_id',
    nav_value: 'nav_value'
}
export function NavBarSiteV1() {

    const ContainerNavRef = useRef();
    const AppDownloadModalRef = useRef();

    const [searchParams, setSearchParams] = useSearchParams();
    const disableNav = searchParams.get('disableNav');

    const [state, setState] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userId, setUserId] = useState(null);
    useEffect(() => {
        if (!state) {
            setState(true);
            return;
        }
        if (disableNav) { return }

        (async () => { setIsAuthenticated(await API_V2_AUTHENTICATED()) })();
        (async () => {
            setUserId((await API_V2_USER_GET(null, ['cpf']))?.['cpf'] || 1)
        })();
        //tem que ter isto para setar o 'ContainerNavRef'

    }, [state])


    const RenderSearchFilter = () => {
        const searchFilterProps = {
            placeholder: 'Buscar produto',
            onKeyUp: (e) => {
                if (e.key === 'Enter') {
                    const query = e.target.value;
                    window.location.href = GLOBAL_TOOME_SEARCH(query);
                }
            }
        }
        return <SearchFilter onKeyUp={searchFilterProps.onKeyUp} placeholder={searchFilterProps.placeholder} />
    }
    return !disableNav && !utils_iam_iframe && <>
        <TopStripe />
        {userId && <nav className={`${CONFIG.CONFIG} ${styles.config} ${styles.Nav}`} ref={ContainerNavRef}>

            <div className={`${styles.NavDivPc} ${styles.NavDivLeft}`}>
                <NavLogo />
                <LeftLinks className={styles.LeftLinks} />
            </div>
            <div className={`${styles.NavDivPc} ${styles.NavDivRight}`}>
                <RenderSearchFilter />
                <DropdownCity />
                <WelcomeLinks
                    userId={userId}
                    isAuthenticated={isAuthenticated}
                    AppDownloadModalRef={AppDownloadModalRef}
                />
            </div>
            <div className={`${styles.NavDivMenu}`}>
                <RenderSearchFilter />
                <MobileMenu
                    userId={userId}
                    isAuthenticated={isAuthenticated}
                    ContainerNavRef={ContainerNavRef}
                    AppDownloadModalRef={AppDownloadModalRef}
                />
            </div>

        </nav >}
        {!isAuthenticated && <button
            onClick={openSignIn}
            className={styles.MobileButtonEnter}
        >Entrar</button>}

        <AppDownloadModal ref={AppDownloadModalRef} />
    </>
}